import axiosInstance from "../../axios/index";
import { alertSuccess } from "../../utils/feedback";
import {
  LOGIN,
  LOGOUT,
  CHECK_ORGA_PROFILE,
  GET_PROFILE,
  AUTOMATIC_LOGOUT,
  AUTOMATIC_LOGOUT_CLOSE,
  GOOGLE_SIGNUP,
  SET_AUTH_DIALOG,
} from "../types/userTypes";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
  loggedOut,
} from "./feedbackActionCreators";
import { setOrgaProfile, resetState } from "./organizationProfileCreators";
import axios from "axios";
import { clearRiskAssessmentStorage } from "../../utils/storageCleanup";
// import {socket} from "../actions/chatbotAction"
// import {disconnectEvent} from "../actions/chatbotAction"

export const login = (token, organization_id, redirectUrl) => ({
  type: LOGIN,
  payload: { token, organization_id, redirectUrl },
});
export const checkOrgaProfile = (orgaId) => ({
  type: CHECK_ORGA_PROFILE,
  payload: { orgaId },
});

export const disconnect = () => ({
  type: LOGOUT,
});

export const automaticLogout = () => ({
  type: AUTOMATIC_LOGOUT,
});

export const automaticLogoutClose = () => ({
  type: AUTOMATIC_LOGOUT_CLOSE,
});

export const getProfile = (profile) => ({
  type: GET_PROFILE,
  payload: profile,
});

export const setGoogleSignUp = (profile) => ({
  type: GOOGLE_SIGNUP,
  payload: profile,
});

export const setAuthDialog = (bol) => ({
  type: SET_AUTH_DIALOG,
  payload: bol,
});

export const automaticSignOut = () => {
  return async (dispatch) => {
    dispatch(automaticLogout());
    localStorage.removeItem("refreshToken");
    clearRiskAssessmentStorage();
    dispatch(requestFailed("automaticLogout"));
  };
};

const revokeGoogleToken = async (googleRefreshToken) => {
  try {
    const response = await axios.post(
      "https://accounts.google.com/o/oauth2/revoke",
      new URLSearchParams({
        token: googleRefreshToken,
      }),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );

    if (response.status !== 200) {
      console.error("Failed to revoke Google token:", response.data);
      return {
        error: "Failed to revoke Google token",
        details: response.data,
      };
    }

    return { success: "Token revoked successfully" };
  } catch (error) {
    console.error("An error occurred:", error);
    return { error: "An error occurred", details: error.message };
  }
};

let logoutInFlight = null;

const getStoredPublicId = () => {
  try {
    return JSON.parse(localStorage.getItem("user"))?.public_id;
  } catch (error) {
    return undefined;
  }
};

const clearLocalSession = (dispatch) => {
  dispatch(requestSucceeded());
  dispatch(loggedOut());
  dispatch(disconnect());
  dispatch(automaticLogoutClose());
  dispatch(setOrgaProfile({}, false, null, null, {}));
  dispatch(resetState());
  clearRiskAssessmentStorage();
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("orgaId");
  localStorage.removeItem("refreshToken");
};

const redirectAfterLogout = (history, data) => {
  if (!history) return;

  history.push("/login");
  if (data?.acceptInvit) {
    alertSuccess({
      message:
        "You just accepted the invitation. You have to reconnect to the application to access as an enterprise's customer",
      message_fr:
        "Vous venez d'accepter l'invitation. Vous devez vous reconnecter Ã  l'application pour y accÃ©der en tant que client d'une entreprise",
    });
  }
};

export const logout = (publicId, history, data) => {
  const refreshToken = localStorage.getItem("refreshToken");
  const resolvedPublicId = publicId || getStoredPublicId();

  return async (dispatch) => {
    // dispatch(requestStarted());
    if (logoutInFlight) {
      return logoutInFlight;
    }

    try {
      logoutInFlight = (async () => {
        if (!resolvedPublicId) {
          return;
        }

        if (refreshToken) {
          await axiosInstance.post(`/auth/google_logout`, {
            public_id: resolvedPublicId,
            google_refresh_token: refreshToken,
          });
        } else {
          await axiosInstance.post(`/auth/logout`, {
            public_id: resolvedPublicId,
          });
        }
      })();

      await logoutInFlight;
      clearLocalSession(dispatch);

      if (history) {
        history.push("/login");
        if (data?.acceptInvit) {
          alertSuccess({
            message:
              "You just accepted the invitation. You have to reconnect to the application to access as an enterprise's customer",
            message_fr:
              "Vous venez d'accepter l'invitation. Vous devez vous reconnecter à l'application pour y accéder en tant que client d'une entreprise",
          });
        }

        return { type: LOGOUT };
      }
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
      clearLocalSession(dispatch);
      redirectAfterLogout(history, data);
    } finally {
      logoutInFlight = null;
    }
  };
};

export const requestLogin = (
  googleLogin,
  email,
  password,
  redirectUrl,
  codeResponse,
  history,
  accountType,
  invitationUid
) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = googleLogin
        ? invitationUid
          ? await axiosInstance.post(`/auth/login_google`, {
              code: codeResponse?.code,
              invitation_uid: invitationUid,
            })
          : await axiosInstance.post(`/auth/login_google`, {
              code: codeResponse?.code,
            })
        : await axiosInstance.post(`/auth/login`, { email, password });
      dispatch(requestSucceeded());

      if (res?.data?.google_register) {
        clearRiskAssessmentStorage();
        dispatch(setGoogleSignUp({ ...res?.data, accountType }));
        if (invitationUid) {
          history.push(`/register?invitation_uid=${invitationUid}`);
        } else {
          history.push("/register");
        }
        const { token } = res.data;
        const { refresh_token } = res.data;
        localStorage.setItem("token", token);
        localStorage.setItem("refreshToken", refresh_token);
      } else {
        clearRiskAssessmentStorage();
        const { token } = res.data;
        const { organization_id } = res.data.user;
        const { user } = res.data;
        const { refresh_token } = res.data;
        localStorage.setItem("token", token);
        localStorage.setItem("orgaId", organization_id);
        localStorage.setItem("user", JSON.stringify(user));
        if (googleLogin) {
          localStorage.setItem("refreshToken", refresh_token);
        }
        dispatch(login(token, organization_id, redirectUrl));
      }
    } catch (error) {
      console.log(error?.response?.data);

      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestRegister = (
  {
    firstName,
    lastName,
    email,
    password,
    confirmPassword,
    phoneNumber,
    country,
    enterprise,
  },
  checked,
  accountType,
  history
) => {
  return async (dispatch, getState) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.post(`/auth/register`, {
        first_name: firstName,
        last_name: lastName,
        email: email,
        country: country,
        password: password,
        confirm_password: confirmPassword,
        phone: phoneNumber,
        entreprise: enterprise,
        check: checked,
        type: accountType,
      });
      dispatch(requestSucceeded());
      alertSuccess(res.data);
      history.push("/login");
    } catch (error) {
      if (error?.response?.status === 300) {
        dispatch(setAuthDialog(true));
        dispatch(requestSucceeded());
      } else {
        console.log({ error });
        dispatch(requestFailed(error?.response?.data));
      }
    }
  };
};

export const requestGoogleRegister = (
  email,
  phoneNumber,
  country,
  enterprise,

  checked,
  accountType,
  providertoken,
  refreshToken,
  invitationUid,
  history
) => {
  return async (dispatch, getState) => {
    const headers = {
      "x-access-token": providertoken,
      "x-refresh-token": refreshToken,
    };
    dispatch(requestStarted());
    try {
      const res = invitationUid
        ? await axios.post(
            `${process.env.REACT_APP_API_URL}/auth/google_register`,
            {
              email: email,
              phone: phoneNumber,
              country: country,
              entreprise: enterprise,

              check: checked,
              type: "free",
              verified_email: true,
              invitation_uid: invitationUid,
            },
            {
              headers,
            }
          )
        : await axios.post(
            `${process.env.REACT_APP_API_URL}/auth/google_register`,
            {
              email: email,
              phone: phoneNumber,
              country: country,
              entreprise: enterprise,

              check: checked,
              type: accountType,
              verified_email: true,
            },
            {
              headers,
            }
          );
      dispatch(requestSucceeded());
      if (history?.push) {
        alertSuccess(res.data);
        clearRiskAssessmentStorage();
        revokeGoogleToken(refreshToken).then((response) => {
          if (response.error) {
            console.error(response.error, response.details);
          } else {
            console.log(response.success);
          }
        });
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        history.push("/login");
        return;
      }
      clearRiskAssessmentStorage();
      const { organization_id } = res.data.user;
      const { user } = res.data;
      const { token } = res.data;
      localStorage.setItem("orgaId", organization_id);
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("token", token);
      dispatch(login(token, organization_id));
      dispatch(setGoogleSignUp({}));
    } catch (error) {
      console.log({ error });
      revokeGoogleToken(refreshToken).then((response) => {
        if (response.error) {
          console.error(response.error, response.details);
        } else {
          console.log(response.success);
        }
      });
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const confirmAccount = ({ code, public_id }, history) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.post(`/auth/confirm_email`, {
        code,
        public_id,
      });
      dispatch(requestSucceeded());
      alertSuccess(res.data);
      history.push("/login");
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const forgotPassword = (email) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.post(`/auth/forgot_password`, { email });
      dispatch(requestSucceeded());
      alertSuccess(res.data);
      // history.push("/login");
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const resetPassword = (token, password, confirm_password, history) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.post(`/auth/reset_password`, {
        token,
        password,
        confirm_password,
      });
      dispatch(requestSucceeded());
      alertSuccess(res.data);
      history.push("/login");
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestCheckOrgaId = (email, orgaName, handleClose) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.post(`/model/check_profile`, {
        email: email,
        organization_name: orgaName,
      });
      dispatch(requestSucceeded());
      alertSuccess(res.data);
      const { organization_id } = res.data;
      localStorage.setItem("orgaId", organization_id);
      dispatch(checkOrgaProfile(organization_id));
      handleClose();
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestUpdatingProfile = (
  first_name,
  last_name,
  avatarSeleceted
) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.put(`/auth/update`, {
        first_name: first_name,
        last_name: last_name,
        avatar_url: avatarSeleceted,
      });
      dispatch(fetchProfile());

      dispatch(requestSucceeded());
      alertSuccess(res.data);
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestChangePassword = (
  oldPassword,
  newPassword,
  confirmPassword
) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.post(`/auth/modify_password`, {
        old_password: oldPassword,
        password: newPassword,
        confirm_password: confirmPassword,
      });
      dispatch(requestSucceeded());
      alertSuccess(res.data);
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const fetchProfile = () => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.get(`/auth/get_user`);
      const profile = res.data;
      const storedUserRaw = localStorage.getItem("user");
      let storedUser = {};
      if (storedUserRaw) {
        try {
          storedUser = JSON.parse(storedUserRaw);
        } catch (e) {
          storedUser = {};
        }
      }

      localStorage.setItem(
        "user",
        JSON.stringify({
          ...storedUser,
          role: profile?.role ?? storedUser?.role,
          account_type: profile?.account_type ?? storedUser?.account_type,
          avatar_url: profile?.avatar_url ?? storedUser?.avatar_url,
          first_name: profile?.first_name ?? storedUser?.first_name,
          last_name: profile?.last_name ?? storedUser?.last_name,
          email: profile?.email ?? storedUser?.email,
          credit_tier: profile?.credit_tier ?? storedUser?.credit_tier,
          credit_remaining: profile?.credit_remaining ?? storedUser?.credit_remaining,
          credit_reserved: profile?.credit_reserved ?? storedUser?.credit_reserved,
          credit_available: profile?.credit_available ?? storedUser?.credit_available,
          credit_tier_costs: profile?.credit_tier_costs ?? storedUser?.credit_tier_costs,
          credit_tiers: profile?.credit_tiers ?? storedUser?.credit_tiers,
          credit_contact_email:
            profile?.credit_contact_email ?? storedUser?.credit_contact_email,
        })
      );
      dispatch(getProfile(profile));
      dispatch(requestSucceeded());
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};
